module.exports = __webpack_public_path__ + "img/Giorgia.6178574.png";